import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, type OnInit, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { AuthService } from '@core/services';
import { ChangableComponent } from '@models/changable.component';
import { Store } from '@ngrx/store';
import { IconComponent } from '@shared/icon/icon.component';
import { getMe } from '@store/reducers/profile.reducer';

import { UserStatusEnum } from 'lingo2-models';
import { filter, takeUntil } from 'rxjs/operators';

export interface EmptyProps {
  title: string;
  text: string;
  link: string;
  link_auth?: boolean;
  link_label: string;
  link2: string;
  image: string;
  action?: boolean;
}

@Component({
  selector: 'app-empty',
  standalone: true,
  imports: [LocaleSharedModule, CommonModule, RouterModule, IconComponent],
  templateUrl: './empty.component.html',
  styleUrls: ['./empty.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyComponent extends ChangableComponent implements OnInit {
  private store = inject(Store);
  private authService = inject(AuthService);

  public isGuest: boolean;
  private _empty: Partial<EmptyProps>;

  @Input() public set empty(empty: Partial<EmptyProps>) {
    this._empty = empty;
  }
  public get empty(): Partial<EmptyProps> {
    return this._empty;
  }

  @Output() onClick = new EventEmitter<boolean>();

  public ngOnInit(): void {
    this.store
      .select(getMe)
      .pipe(
        filter((me) => !!me.id),
        takeUntil(this.destroyed$),
      )
      .subscribe({
        next: (me) => (this.isGuest = me.status === UserStatusEnum.guest),
        error: (error) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
        },
      });
  }

  public getImageUrl(): string {
    return '/assets/images/my-classes-empty/' + this.empty?.image + '.jpg';
  }

  public goSignup(e: Event) {
    if (this.empty?.link_auth && this.isGuest) {
      this.authService.showAuthModal();
    }

    if (this.empty.action) {
      this.onClick.emit(true);
    }
  }
}
